export type ActivityType = 'falar_com_frila' | 'revisao_cadastro' | 'mencao';
export type ActivityStatus = 'pending' | 'completed';
export type ActivityThermometer = 'muito_frio' | 'frio' | 'neutro' | 'quente' | 'muito_quente';

// Etapas do Kanban para "Fazer Amizade"
export type FazerAmizadeEtapa = 'pendente' | 'em_contato' | 'concluido' | 'nao_respondeu';

export const FAZER_AMIZADE_ETAPAS: Array<{
  id: FazerAmizadeEtapa;
  nome: string;
  cor: string;
  tipo: 'ativa' | 'sucesso' | 'falha';
}> = [
  { id: 'pendente', nome: 'Pendentes', cor: 'slate', tipo: 'ativa' },
  { id: 'em_contato', nome: 'Em Contato', cor: 'blue', tipo: 'ativa' },
  { id: 'concluido', nome: 'Concluidos', cor: 'green', tipo: 'sucesso' },
  { id: 'nao_respondeu', nome: 'Nao Respondeu', cor: 'red', tipo: 'falha' },
];

export const ACTIVITY_TYPE_LABELS: Record<ActivityType, string> = {
  falar_com_frila: 'Fazer Amizade',
  revisao_cadastro: 'Revisao de Cadastro',
  mencao: 'Mencao',
};

export const THERMOMETER_CONFIG: Record<ActivityThermometer, { emoji: string; label: string; color: string }> = {
  muito_frio: { emoji: '🥶', label: 'Muito Frio', color: 'text-blue-600' },
  frio: { emoji: '😕', label: 'Frio', color: 'text-cyan-500' },
  neutro: { emoji: '😐', label: 'Neutro', color: 'text-gray-500' },
  quente: { emoji: '😊', label: 'Quente', color: 'text-orange-500' },
  muito_quente: { emoji: '🔥', label: 'Muito Quente', color: 'text-red-500' },
};

export const THERMOMETER_OPTIONS: ActivityThermometer[] = [
  'muito_frio',
  'frio',
  'neutro',
  'quente',
  'muito_quente',
];

export interface Activity {
  id: number;
  freelancer_id: string | null;
  tipo: ActivityType;
  status: ActivityStatus;
  etapa_kanban: FazerAmizadeEtapa | null;
  observacao: string | null;
  assigned_to: string | null;
  created_by: string;
  created_at: string;
  completed_at: string | null;
  completed_by: string | null;
  termometro: ActivityThermometer | null;
  conversa_whatsapp: string | null;
  sentimento: string | null;
  resumo: string | null;
  evaluation_group_freelancer_id: number | null;
  vaga_observacao_id: string | null;
}

export interface ActivityDetail extends Activity {
  // Campos de freelancer (opcionais para mencoes)
  freelancer_nome: string | null;
  freelancer_email: string | null;
  freelancer_telefone: string | null;
  freelancer_cidade: string | null;
  freelancer_portfolio_url: string | null;
  freelancer_linkedin_url: string | null;
  freelancer_areas: string[] | null;
  // Campos de vaga (para mencoes)
  vaga_id: string | null;
  vaga_titulo: string | null;
  observacao_mensagem: string | null;
  // Usuarios
  assigned_to_name: string | null;
  created_by_name: string | null;
  completed_by_name: string | null;
}

export interface PendingActivityInfo {
  id: number;
  freelancer_id: string | null;
  tipo: ActivityType;
  status: ActivityStatus;
  observacao: string | null;
  assigned_to: string | null;
  assigned_to_name: string | null;
  created_by: string;
  created_by_name: string | null;
  created_at: string;
}

// Aliases para retrocompatibilidade (deprecated - usar Activity e ActivityDetail)
/** @deprecated Use Activity instead */
export type FreelancerActivity = Activity;
/** @deprecated Use ActivityDetail instead */
export type FreelancerActivityDetail = ActivityDetail;
